import React from 'react'

import i18n from 'i18n-literally'
import { useConnect } from 'redux-bundler-hook'

import { Box } from '@mui/material'

import { Form, Formik, useFormikContext } from 'formik'

import createLogger from '~/src/Lib/Logging'
import { REGISTER_ROUTES } from '~/src/Routes/constants'
import SetPassword from '~/src/Routes/Shared/SetPassword'
import { SUBMIT_REQUIREMENTS } from '~/src/Routes/utils'
import Button from '~/src/UI/Shared/Button'
import T from '~/src/UI/Shared/Typography'

const displayName = 'CreatePassword'
const logger = createLogger(displayName)

const Password = ({
  handleGoBackStep,
}) => {
  const { isValid, errors } = useFormikContext()

  const fields = Object.fromEntries(
    Object.entries(SUBMIT_REQUIREMENTS)
      .map(([key, { description }]) => [key, { description, error: errors[key] }])
  )

  return (
    <Form>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="2rem"
      >
        <T.H3>{i18n`Create Password`}</T.H3>
        <Box
          minWidth={350}
          display="flex"
          flexDirection="column"
          gap="3rem"
        >
          <SetPassword fields={fields} />
          <Box display="flex" justifyContent="space-between">
            <Button
              variant="text"
              onClick={handleGoBackStep}
            >
              {i18n`Go back`}
            </Button>
            <Button
              disabled={!isValid}
              type="submit"
              sx={{ padding: '0 3rem' }}
            >
              {i18n`Next`}
            </Button>
          </Box>
        </Box>
      </Box>
    </Form>
  )
}

const Connected = props => {
  const { doUpdateUrl } = useConnect('doUpdateUrl')
  const handleSubmit = () => {
    // Dummy code to check success and error pages
    const success = true
    if (success) {
      doUpdateUrl(REGISTER_ROUTES.ACCOUNT_SUCCESS)
    }
    doUpdateUrl(REGISTER_ROUTES.ACCOUNT_ERROR)
  }
  return (
    <Formik
      validateOnMount
      initialValues={{
        password1: '',
        password2: ''
      }}
      onSubmit={handleSubmit}
      validate={values => Object.fromEntries(
        Object.entries(SUBMIT_REQUIREMENTS)
          .filter(([, { test }]) => test(values))
          .map(([key]) => [key, true])
      )}
    >
      <Password {...props} />
    </Formik>
  )
}

const Memoized = React.memo(Connected)
export default Memoized
